enum HttpStatusCode {
  BadRequest = 400,
  Unauthorized = 401,
  NotFound = 404,
}

export default HttpStatusCode;
